import { useEffect, useState } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import axios from 'axios';

import StripeCheckoutForm from './CheckoutForm';

// Initialize loadStripe outside of component
// https://docs.stripe.com/connect/authentication?create-client=react
const getStripePromise = stripeAccountId => {
  return loadStripe(process.env.REACT_APP_STRIPE_KEY, {
    ...(stripeAccountId && { stripeAccount: stripeAccountId })
  });
};

const StripeComponent = ({ connectedAccountNumber, customerId, invoice, userId }) => {
  const [clientSecret, setClientSecret] = useState();
  const [stripePromise, setStripePromise] = useState(null);

  useEffect(() => {
    const retrievePaymentIntent = async () => {
      // Create payment intent as soon as the page loads
      try {
        const createPaymentIntentResponse = await axios.post(`${process.env.REACT_APP_API_URL}/payments/stripe/payment-intent`, {
          amount: (invoice.amountDue ?? 0 - invoice.amountPaid ?? 0) * 100, // Convert to cents
          customerId,
          invoiceId: invoice.invoiceId,
          userId
        });

        if (connectedAccountNumber) {
          // Set stripe promise with the account ID from response
          setStripePromise(getStripePromise(connectedAccountNumber));

          setClientSecret(createPaymentIntentResponse.data.clientSecret);
        }
      } catch (error) {
        console.error('Payment intent creation error:', error);
      }
    };

    // createPaymentIntent();
    if (!clientSecret) {
      retrievePaymentIntent();
    }
  }, [clientSecret, connectedAccountNumber, customerId, invoice, userId]);

  if (!clientSecret || !stripePromise) return null;

  return (
    <Elements options={{ clientSecret }} stripe={stripePromise}>
      <StripeCheckoutForm />
    </Elements>
  );
};

export default StripeComponent;
